/**
 * Where a buyer lands after paying for an async review.
 *
 * Stripe sends the buyer to `/review/{id}/success` (backend `success_url` in
 * routes/bookings_mcp.py). That URL had no frontend route, so the page a buyer
 * saw right after paying was the 404 screen. The buyer-facing review page
 * already exists at /verifications/{id} ("Your review is in progress" until a
 * verdict is submitted), so the success URL forwards there.
 *
 * That page is behind login and an MCP buyer may not be signed in on the web,
 * so a signed-out buyer goes to /login and is returned to it afterwards
 * (LoginPage honours a same-origin `return_to`). The id comes from the URL, so
 * anything that is not a UUID is not used to build a path.
 */

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function reviewSuccessTarget(reviewId, signedIn) {
  if (!UUID_RE.test(reviewId || "")) {
    return signedIn ? "/dashboard" : "/";
  }
  const detail = `/verifications/${reviewId}`;
  return signedIn ? detail : `/login?return_to=${encodeURIComponent(detail)}`;
}
